import React, { createContext, useState, useCallback } from 'react';

export const GameContext = createContext();

export const GameProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [triggerGameEnd, setTriggerGameEnd] = useState(false);
  const [isGameActive, setIsGameActive] = useState(false);
  const [flagImageUrl, setFlagImageUrl] = useState('');
  const [resultsWord, setResultsWord] = useState('Results');
  const [grammarOptions, setGrammarOptions] = useState([]);
  const [languageData, setLanguageData] = useState([]);
  const [learnedWords, setLearnedWords] = useState([]);
  const [grammarQuestionsList, setGrammarQuestionsList] = useState([]);
  const [learnedGrammarList, setLearnedGrammarList] = useState([]);
  const [languageTips, setLanguageTips] =useState([]);

  const handleLanguageChange = useCallback((languageCode) => {
    setSelectedLanguage(languageCode);
  }, []);

  const triggerGameEndIfActive = useCallback(() => {
    if (isGameActive) {
      setTriggerGameEnd(true);
    }
  }, [isGameActive]);

  const handleGameEndComplete = useCallback(() => {
    setTriggerGameEnd(false);
  }, []);

  const setGameActiveStatus = useCallback((status) => {
    setIsGameActive(status);
  }, []);

  const updateFlagImageUrl = useCallback((url) => {
    setFlagImageUrl(url);
  }, []);

  const updateResultsWord = useCallback((word) => {
    console.log('results word ',word)
    setResultsWord(word);
  }, []);

  const updateGrammarOptions = useCallback((grammar_options) => {
    setGrammarOptions(grammar_options);
  }, []);

  const loadLanguageData = useCallback((vocab_words) => {
    setLanguageData(vocab_words);
  }, []);

  const loadUsersLearnedWords = useCallback((learned_words) => {
    console.log('loading users learned words')
    setLearnedWords(learned_words);
  }, []);

  const updateLearnedList = (updatedLearnedList) => {
   console.log('handling updateLearnedList ==')
    setLearnedWords(updatedLearnedList);
  };

  const loadGrammarQuestions = useCallback((grammar_questions) => {
    console.log('loadGrammarQuestions ==')
    console.log(grammar_questions.length)
    setGrammarQuestionsList(grammar_questions);
  }, []);

  const loadUsersLearnedGrammar = useCallback((learned_grammar) => {
        console.log('loadLearnedGrammar ==')
    console.log(learned_grammar)
    setLearnedGrammarList(learned_grammar);
  }, []);

  const updateLearnedGrammarList = (updatedLearnedGrammarList) => {
    console.log('in Game Context learned_list length ==' + updatedLearnedGrammarList ? updatedLearnedGrammarList.length : "0")
    setLearnedGrammarList(updatedLearnedGrammarList);
  };

  const loadTips = useCallback((tips) => {
    console.log('loading users learned words')
    setLanguageTips(tips);
  }, []);



  return (
    <GameContext.Provider value={{
      selectedLanguage,
      triggerGameEnd,
      isGameActive,
      flagImageUrl,
      resultsWord,
      grammarOptions,
      languageData,
      learnedWords,
      grammarQuestionsList,
      learnedGrammarList,
      languageTips,
      onLanguageChange: handleLanguageChange,
      triggerGameEndIfActive,
      onGameEndComplete: handleGameEndComplete,
      setGameActiveStatus,
      updateFlagImageUrl,
      updateResultsWord,
      updateGrammarOptions,
      loadLanguageData,
      loadUsersLearnedWords,
      updateLearnedList,
      loadGrammarQuestions,
      loadUsersLearnedGrammar,
      updateLearnedGrammarList,
      loadTips
    }}>
      {children}
    </GameContext.Provider>
  );
};